import $ from "jquery";
import cookies from "vue-cookies";
export default {
    name: "Home",
    // components: {
    //   HelloWorld,
    // },
    data() {
        return {
            searchContent: ""
        };
    },
    mounted() {
        // 统一验证token
        var currentToken = cookies.get("token");
        $.ajaxSetup({
            headers: {
                AuthorizationToken: currentToken,
            },
            complete: function (xhr) {
                if (xhr.responseJSON.code == 401) {
                    window.location.href = "/";
                }
            },
        });
    },
    methods: {
        onSearch() {
            console.log(this.searchContent);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "/zyk/webapi/search",
                data: {
                    content: this.searchContent
                },
                // contentType: "application/json;charset=utf-8",
                success: function (data) {
                    if (data.code == 200) {
                        console.log(data.obj.wordList);
                    } else {
                        alert(data.msg);
                    }
                },
                error: function () {
                    console.log("失败了");
                },
            });
        }
    }
};